<div class="avatar"
     [ngClass]="{'background': withBg}"
     [title]="(user | async) ? (user | async).firstLastName : userName">
     <img src="{{ src | async }}"
          alt="{{ userName }}"
          [attr.width]="size"
          [attr.height]="size"
          loading="lazy" />
</div>